import {ApplicationRef, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {DocumentService} from '@orga-app/providers/document.service';
import {ImageService} from '@orga-app/providers/image.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ActionSheetController, IonRefresher, NavController} from '@ionic/angular';
import * as apiVeranstaltungen from '../../../../clients/veranstaltungen';
import {
    FunktionsbereichRolleBenutzerListe,
    InfoKategorie,
    KopfdatenElement,
    VeranstaltungDetail
} from '../../../../clients/veranstaltungen';
import {Observable, of} from 'rxjs';
import {WindowRefService} from '@orga-app/providers/window.service';
import {select, Store} from '@ngrx/store';
import {catchError, filter, takeWhile} from 'rxjs/operators';
import {Settings, SettingsProvider} from '@orga-app/settings';
import * as fromVeranstaltungHomePage from './veranstaltung-home.reducer';
import * as fromAppState from '../../app-state/app-state.reducer';
import {getFunktionsbereicheRollenListe, getInfoKategorien} from './veranstaltung-home.reducer';
import {FunktionsbereichRolleBenutzerListeUi, InfoKategorieUi} from './veranstaltung-home.model.ui';
import {getAktuelleVeranstaltung, getAktuelleVeranstaltungenFehler, getAktuelleVeranstaltungenLaden, getVeranstaltungDeckblatt, getVeranstaltungDeckblattFehler, getVeranstaltungDeckblattLaden} from '../../app-state/app-state.reducer';
import {PageStateResetAction, ToggleInfoKategorieAction, ToggleRolleAction} from './veranstaltung-home.actions.ui';
import {PageLoadDataAction} from '../../app-state/actions/veranstaltung.actions';

@Component({
    selector: 'app-veranstaltung-home',
    templateUrl: './veranstaltung-home.page.html',
})
export class VeranstaltungHomePage implements OnInit {
    @ViewChild(IonRefresher, { static: false})
    refresher: IonRefresher;
    // @ViewChild('logoImagePlaceholder', {static: true, read: ElementRef}) logoImagePlaceholder: ElementRef;
    public veranstaltungDeckblatt$: Observable<VeranstaltungDetail>;
    public uiZeigeVeranstaltungDeckblattLaden$: Observable<boolean>;
    public uiZeigeVeranstaltungDeckblattLadefehler$: Observable<boolean>;
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    public logoHeaderSVG$: Observable<SafeUrl>;
    public sectionVlIstOffen = true;
    public sectionOrdnerIstOffen = false;
    public infoKategorien$: Observable<Array<InfoKategorieUi>>;
    public fbRollen$: Observable<Array<FunktionsbereichRolleBenutzerListeUi>>;
    image: any;
    veranstaltungsId: string;
    logoBlobId: string;
    public tbrTest = true;
    private aiName = 'VeranstaltungHomePage';
    private aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    private uiZeigeVeranstaltungenAktuelleLaden$: Observable<boolean>;
    private uiZeigeVeranstaltungenAktuelleLadefehler$: Observable<boolean>;
    private alive = true;
    private windowRef: Window;
    private aktuelleVeranstaltungId: string;

    constructor(public navCtrl: NavController,
                // public navParams: NavParams,
                public domSanitizer: DomSanitizer,
                private imageService: ImageService,
                private documentService: DocumentService,
                private windowRefService: WindowRefService,
                private store: Store<fromVeranstaltungHomePage.PageState>,
                private zone: NgZone,
                private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
                public actionSheetCtrl: ActionSheetController,
                private settingsProvider: SettingsProvider,
                private appRef: ApplicationRef) {
        // this.settings$ = this.settingsProvider.getActiveTheme();
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();

    }

    ngOnInit() {
        this.windowRef = this.windowRefService.nativeWindow;
        // Veranstaltung
        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltung));
        this.uiZeigeVeranstaltungenAktuelleLaden$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenLaden));
        this.uiZeigeVeranstaltungenAktuelleLadefehler$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenFehler));

        // VeranstaltungDeckblatt
        this.veranstaltungDeckblatt$ = this.store.pipe(select(getVeranstaltungDeckblatt));
        this.uiZeigeVeranstaltungDeckblattLaden$ = this.store.pipe(select(getVeranstaltungDeckblattLaden));
        this.uiZeigeVeranstaltungDeckblattLadefehler$ = this.store.pipe(select(getVeranstaltungDeckblattFehler));

        this.infoKategorien$ = this.store.pipe(select(getInfoKategorien));
        this.fbRollen$ = this.store.pipe(select(getFunktionsbereicheRollenListe));
        // Logo laden
        this.veranstaltungDeckblatt$.subscribe(x => {
            if (x != null && x.logo_blob_id != null && x.logo_blob_id !== '') {
                if (this.veranstaltungsId !== x.veranstaltung_id || this.logoBlobId !== x.logo_blob_id) {
                    this.imageService.getImage('/api/query/veranstaltungen/' + x.veranstaltung_id + '/logo/scale/200/200')
                        .pipe(
                            takeWhile(() => this.alive)
                            , filter(image => {
                                return !!image;
                            }),
                            catchError((error: any) => {
                                return of();
                            }),
                        )
                        .subscribe((image: BlobPart) => {
                                if (image) {
                                    this.veranstaltungsId = x.veranstaltung_id;
                                    this.logoBlobId = x.logo_blob_id;
                                    const blob = new Blob([image]);

                                    const urlCreator = window.URL;
                                    this.zone.run(() => {
                                        this.image = this.domSanitizer.bypassSecurityTrustUrl(
                                            urlCreator.createObjectURL(blob));
                                    });
                                }
                            },
                            error => {
                                this.zone.run(() => {
                                    this.image = null;
                                });

                                console.log('DRINNEN ERROR');
                            });
                }
            } else {
                this.zone.run(() => {
                    this.image = null;
                });
                this.appRef.tick();
            }
        });
        this.uiZeigeVeranstaltungDeckblattLaden$.subscribe(() => {
            // this.appRef.tick();
        });
    }

    ionViewWillEnter() {
        console.log('Daten neu laden!!! ');
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        // console.log('Daten neu laden!!! ');
        this.store.dispatch(new PageStateResetAction());
        await this.datenErneutLaden();
        // console.debug('VeranstaltungHomePage');
    }

    ionViewDidEnter() {
        if (this.refresher !== undefined) {
            this.refresher.disabled = false;
        }
    }

    ionViewWillLeave() {
        if (this.refresher !== undefined) {
            this.refresher.disabled = true;
        }
    }

    async veranstaltungDeckblattLaden() {
        this.store.dispatch(new PageLoadDataAction());
    }

    parseAnzeigeFeld(veranstaltung: VeranstaltungDetail, parseString: string) {
        if (parseString === null) {
            return '';
        }
        parseString = parseString.replace('{{TITEL}}', (veranstaltung.titel !== null) ? veranstaltung.titel : '');
        parseString = parseString.replace('{{SAISON}}', (veranstaltung.saison !== null) ? veranstaltung.saison : '');
        parseString = parseString.replace('{{TYP_BEZEICHNUNG}}', (veranstaltung.typ_bezeichnung !== null) ? veranstaltung.typ_bezeichnung : '');
        parseString = parseString.replace('{{EINLASS:d}}', new Date(veranstaltung.einlass_utc).toLocaleDateString());
        parseString = parseString.replace('{{BEGINN:d}}', new Date(veranstaltung.beginn_utc).toLocaleDateString());
        parseString = parseString.replace('{{EINLASS:t}}', new Date(veranstaltung.einlass_utc).toLocaleTimeString().substring(0, 5));
        parseString = parseString.replace('{{BEGINN:t}}', new Date(veranstaltung.beginn_utc).toLocaleTimeString().substring(0, 5));
        veranstaltung.kopfdaten.forEach(item => {
            let wert = item.wert;
            if (item.feld_typ === 'GRUPPE') {
                wert = this.getSumme(item.children).toLocaleString('DE').toString();
            }

            parseString = parseString.replace('{{' + item.key + '}}', (wert !== null) ? wert : '');
        });

        return parseString;
    }

    async presentActionSheet(veranstaltungsleiter: apiVeranstaltungen.Benutzer) {
        const buttons = [];
        veranstaltungsleiter.telefone.forEach(phone => {
            buttons.push({
                text: phone.nummer,
                icon: 'call',
            });
        });

        if (buttons.length === 0) {
            buttons.push({
                text: 'Keine Telefonnummern hinterlegt',
                icon: 'ios-information-circle',
                handler: () => {
                }
            });
        }

        buttons.push({
            text: 'Abbrechen',
            icon: 'close',
            role: 'cancel',
            handler: () => {
            }
        });


        const actionSheet = await this.actionSheetCtrl.create({
            header: veranstaltungsleiter.display_vorname_nachname,
            backdropDismiss: true,
            buttons
        });
        await actionSheet.present();
    }

    async pageAktualisieren(event) {
        await this.datenErneutLaden();
        // await event.target.complete();
        setTimeout(function () {
            event.target.complete();
        }.bind(this), 200);
    }

    async datenErneutLaden() {
        await this.veranstaltungDeckblattLaden();
    }

    async toggleSectionVl() {
        this.sectionVlIstOffen = !this.sectionVlIstOffen;
    }

    async toggleSectionOrdner() {
        this.sectionOrdnerIstOffen = !this.sectionOrdnerIstOffen;
    }

    logoPadding(veranstaltung) {
        return (this.image != null && veranstaltung !== null && veranstaltung.logo_blob_id !== null) ? '20px' : '0px';
    }

    async toggleSection(kategorie: InfoKategorie) {
        this.store.dispatch(new ToggleInfoKategorieAction(kategorie.kategorie_id));
        // this.infoKategorien[i].open = !this.infoKategorien[i].open;
    }

    toggleSectionRolle(fbRolleBenutzer: FunktionsbereichRolleBenutzerListeUi) {
        this.store.dispatch(new ToggleRolleAction(fbRolleBenutzer.rolle.rolle_id));
    }


    trackByKopfdaten(index: number, feld: KopfdatenElement) {
        return index + feld.key;
    }

    trackByRolle(index: number, rolleBenutzer: FunktionsbereichRolleBenutzerListe) {
        return rolleBenutzer.rolle.rolle_id;
    }

    getSumme(children: Array<KopfdatenElement>) {
        let ret = 0;

        children.forEach(x => {
            if (x.daten_typ === 'INT' && x.wert !== undefined && x.wert !== null && x.wert !== '' && (Number(x.wert).toString() !== 'NaN')) {
                ret = ret + Number(x.wert);
            }
        });
        return ret;
    }

    trackByInfoKategorien(index, item: InfoKategorieUi) {
        return item.kategorie_id;
    }
}
